
export default {
  name: 'GridContainerBase',
  values: {
    display: 'grid',
    gridTemplateColumns: undefined,
    gridTemplateRows: undefined,
    gridTemplateAreas: undefined,
    gridAutoRows: undefined,
    gridAutoColumns: undefined,
    gridAutoFlow: undefined,
    justifyItems: undefined,
    alignItems: undefined,
    justifyContent: undefined,
    alignContent: undefined,
  },
  meta: {
    extendable: false,
  },
}
